export default __webpack_public_path__ + "static/media/rounded-arrow.e3e04766.svg";